<mat-toolbar class="header mat-elevation-z4" style="background-color: purple;">
    <span class="title-group">
        <a mat-list-item routerLink="/">
            <i class="material-icons">
                home
            </i>
            Início
        </a>
    </span>
    <span class="title-group">
        <a mat-list-item routerLink="/wines">
            <i class="material-icons">
                local_bar
            </i>
            Vinhos
        </a>
    </span>
    <span class="title-group">
        <a mat-list-item routerLink="/users">
            <i class="material-icons">
                person
            </i>
            Usuários
        </a>
    </span>
    <span class="example-spacer"></span>
    <div class="cadastro">
        <button mat-icon-button class="example-icon person-icon" [matMenuTriggerFor]="menu">
            <mat-icon>login</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <button *ngIf="username==null" mat-menu-item (click)="autenticar()">Fazer login</button>
            <button *ngIf="username==null" mat-menu-item (click)="registrar()">Registrar</button>
            <button *ngIf="username!=null" mat-menu-item (click)="sair()">Sair</button>
        </mat-menu>
    </div>
    <div class="login">
        <span>{{ username == null ? 'Logar' : username}}</span>
    </div>
</mat-toolbar>
<div class="content">
    <router-outlet></router-outlet>
</div>